/* This component UPDATES one entry in the historys collection in MongoDB.
   This component should use the HistoryRead component to showw the items
   available for UPDATE. This compoent should allow for deletion of any
   entry in the selected history entry. HistoryDelete should only be used
   to delete an entire history entry in MongoDB. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import { CLIENT_PUBLIC_TOKEN }         from '../config.js'
import Grid                            from "@material-ui/core/Grid"
import { node_server }                 from '../Helpers/index.js'
import Paper                           from "@material-ui/core/Paper"
import PropTypes                       from 'prop-types'
import Typography                      from "@material-ui/core/Typography"

const HistoryUpdateComponent = ({ entry, id }) => {

   const [ displayEntry,  setDisplayEntry       ]  =  useState([])

   
   const handleEntry = (id) => {
      entry.entries.map( (e, i) => {
         if (e._id === id) {
            console.log('You clicked on entry index', i)
         }
      } )
   }
   
   const handleLink = (id) => {
      entry.links.map( (e, i) => {
         if (e._id === id) {
            console.log('You clicked on link index', i)
         }
      } )
   }

   const handleTitle = () => {
      
   }

   useEffect( () => {
      console.log('HistoryEntries useEffect is running')
      console.log('entry is', entry)
      setDisplayEntry(
         <Grid key={entry._id} >
            <Typography key={entry.title._id} variant='h5' align='left' style={{ marginBottom: '5px', marginTop: '5px' }} onClick={() => handleTitle()} >
               { entry.title }
            </Typography>
            {entry.entries.length > 0
               ?
                  entry.entries.map( (e, i) => {
                     if (e.entryType === 'text') {
                        return(
                           <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} onClick={() => handleEntry(e._id)} >
                              { e.entry }
                           </Typography>
                        )
                     }
                     else if(e.entryType === 'bullet') {
                        return(
                           <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }} onClick={() => handleEntry(e._id)} >
                              { e.entry }
                           </Typography>
                        )
                     }
                     return null
                  } )
               :
                  null
            }
            {entry.links.length > 0
               ?
                  entry.links.map( (link, i) => {
                     return(
                        <Typography key={link._id + i} variant='h6' style={{ textAlign: 'left', marginBottom: '10px', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleLink(link._id)} >
                           { link.caption }
                        </Typography>
                     )
                  })
               :
                  null
            }
         </Grid>
         )
   }, [])

   return (
      <Box>
         <Grid style={{ marginTop: '6rem', padding: '2rem' }} >
            { displayEntry }
         </Grid>
      </Box>
   )
}

HistoryUpdateComponent.propTypes = {
   entry:   PropTypes.object,
   id:      PropTypes.string
}

export default HistoryUpdateComponent
